"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createExternalManagement = createExternalManagement;
exports.deleteExternalManagement = deleteExternalManagement;
exports.getExternalManagementList = getExternalManagementList;
exports.updateExternalManagement = updateExternalManagement;
var _request = _interopRequireDefault(require("@/utils/request"));
function getExternalManagementList(query) {
  return (0, _request.default)({
    url: '/system/externalmanagement/',
    method: 'get',
    params: query
  });
}
function createExternalManagement(data) {
  return (0, _request.default)({
    url: '/system/externalmanagement/',
    method: 'post',
    data: data
  });
}
function updateExternalManagement(id, data) {
  return (0, _request.default)({
    url: "/system/externalmanagement/".concat(id, "/"),
    method: 'put',
    data: data
  });
}
function deleteExternalManagement(id) {
  return (0, _request.default)({
    url: "/system/externalmanagement/".concat(id, "/"),
    method: 'delete'
  });
}